import { Expose } from "class-transformer";

export class CopyPlanningDataDto {
  @Expose()
  sourceProjectId: string;
}
